import e from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import n from "../../common/mixins/modal.js";
import { NOTICE_KINDS as r } from "../notice/notice-constants.js";
import i from "../notice/notice-icon.js";
import a from "../notice/notice-content.js";
import o from "../notice/notice-action.js";
import { createBlock as s, createCommentVNode as c, createElementBlock as l, createElementVNode as u, createVNode as d, normalizeClass as f, normalizeStyle as p, openBlock as m, renderSlot as h, resolveComponent as g, withCtx as _, withKeys as v } from "vue";
//#region components/banner/banner.vue
var y = {
	compatConfig: { MODE: 3 },
	name: "DtBanner",
	components: {
		DtNoticeIcon: i,
		DtNoticeContent: a,
		DtNoticeAction: o
	},
	mixins: [n],
	props: {
		headerId: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		contentId: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		headerText: {
			type: String,
			default: void 0
		},
		important: {
			type: Boolean,
			default: !1
		},
		pinned: {
			type: Boolean,
			default: !1
		},
		kind: {
			type: String,
			default: "base",
			validator(e) {
				return r.includes(e);
			}
		},
		showClose: {
			type: Boolean,
			default: !0
		},
		showIcon: {
			type: Boolean,
			default: !0
		},
		showAction: {
			type: Boolean,
			default: !0
		},
		dialogClass: {
			type: String,
			default: ""
		},
		backgroundImage: {
			type: String,
			default: ""
		},
		backgroundSize: {
			type: String,
			default: "cover"
		},
		iconClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		headerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		contentClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		actionClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	},
	emits: ["close"],
	computed: {
		role() {
			return this.important ? "alertdialog" : "status";
		},
		bannerClass() {
			return [
				"d-banner",
				{
					critical: "d-banner--critical",
					info: "d-banner--info",
					positive: "d-banner--positive",
					warning: "d-banner--warning",
					base: "d-banner--base"
				}[this.kind],
				{
					"d-banner--important": this.important,
					"d-banner--pinned": this.pinned
				}
			];
		},
		bannerBackgroundImage() {
			return this.backgroundImage === "" ? null : `background-image: url(${this.backgroundImage});
              background-size: ${this.backgroundSize};`;
		}
	},
	mounted() {
		this.important && this.focusFirstElement();
	},
	methods: { trapFocus(e) {
		this.important && this.focusTrappedTabPress(e);
	} }
}, b = [
	"role",
	"aria-labelledby",
	"aria-describedby"
];
function x(e, t, n, r, i, a) {
	let o = g("dt-notice-icon"), y = g("dt-notice-content"), x = g("dt-notice-action");
	return m(), l("aside", {
		class: f(a.bannerClass),
		style: p(a.bannerBackgroundImage),
		onKeydown: t[1] || (t[1] = v((...e) => a.trapFocus && a.trapFocus(...e), ["tab"]))
	}, [u("div", {
		class: f(["d-banner__dialog", n.dialogClass]),
		role: a.role,
		"aria-labelledby": n.headerId,
		"aria-describedby": n.contentId
	}, [
		n.showIcon ? (m(), s(o, {
			key: 0,
			kind: n.kind,
			"icon-class": n.iconClass,
			class: f({ "d-notice__icon--has-title": n.headerText || e.$slots.header })
		}, {
			default: _(() => [h(e.$slots, "icon")]),
			_: 3
		}, 8, [
			"kind",
			"icon-class",
			"class"
		])) : c("", !0),
		d(y, {
			"header-id": n.headerId,
			"content-id": n.contentId,
			"header-text": n.headerText,
			"header-class": n.headerClass,
			"content-class": n.contentClass
		}, {
			header: _(() => [h(e.$slots, "header")]),
			default: _(() => [h(e.$slots, "default")]),
			_: 3
		}, 8, [
			"header-id",
			"content-id",
			"header-text",
			"header-class",
			"content-class"
		]),
		d(x, {
			"show-action": n.showAction,
			"show-close": n.showClose,
			"action-class": n.actionClass,
			onClose: t[0] || (t[0] = (t) => e.$emit("close"))
		}, {
			default: _(() => [h(e.$slots, "action")]),
			_: 3
		}, 8, [
			"show-action",
			"show-close",
			"action-class"
		])
	], 10, b)], 38);
}
var S = /* @__PURE__ */ t(y, [["render", x]]);
//#endregion
export { S as default };

//# sourceMappingURL=banner.js.map